export interface RatingBoundsSpec {
  readonly ratingMin: number | null;
  readonly ratingMax: number | null;
}

export interface RatingBounds {
  readonly min: number;
  readonly max: number;
}

export function resolveRatingBounds(spec: RatingBoundsSpec): RatingBounds {
  return {
    min: spec.ratingMin ?? 1,
    max: spec.ratingMax ?? 5,
  };
}

export function listRatingScaleValues(
  spec: RatingBoundsSpec
): readonly number[] {
  const { min, max } = resolveRatingBounds(spec);

  return Array.from({ length: max - min + 1 }, (_, index) => min + index);
}
